import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Blur = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featurePages effect">
      <div className="header">
        <div className="headerContent">
          <h2 className="title">{t('contents:effectTitle1')}</h2>
          <p className="text">
            {t('contents:effectParagraph1')}
            <br />
            <br />
            {t('contents:effectParagraph2')}
          </p>
        </div>
        <img src={require('../../../assets/images/features/pages/effect/effect_01.png')} />
      </div>
      <div className="content">
        <div className="container">
          <div className="section section01">
            <div className="textBox">
              <p>
                {t('contents:effectParagraph3')}
                <br />
                <br />
                {t('contents:effectParagraph4')}
              </p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/effect/effect_05.png')} />
            </div>
          </div>
          <div className="section section02">
            <div className="textBox">
              <h2 className="title">{t('contents:effectTitle2')}</h2>
              <p>{t('contents:effectParagraph5')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/effect/effect_06.png')} />
            </div>
          </div>
          <div className="section section03">
            <div className="textBox">
              <h2 className="title">{t('contents:effectTitle3')}</h2>
              <p>{t('contents:effectParagraph6')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/effect/effect_07.png')} />
            </div>
          </div>
          <div className="section section04">
            <div className="textBox">
              <h2 className="title">{t('contents:effectTitle4')}</h2>
              <p>{t('contents:effectParagraph7')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/effect/effect_08.png')} />
            </div>
          </div>
          <div className="section section05">
            <div className="textBox">
              <h2 className="title">{t('contents:effectTitle5')}</h2>
              <p>{t('contents:effectParagraph8')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/effect/effect_09.png')} />
            </div>
          </div>
          <div className="section section06">
            <div className="textBox">
              <h2 className="title">{t('contents:effectTitle6')}</h2>
              <p>{t('contents:effectParagraph9')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/effect/effect_10.png')} />
            </div>
          </div>
        </div>
        <div className="footer"></div>
      </div>
    </Container>
  );
};

export default Blur;
